import axios from 'axios'
import { AxiosError } from 'axios'
import { ApiError } from '@app/api/api-error'
import { readToken } from '@app/store/services/local-storage.service'

import config from '../config'

export const httpApi = axios.create({
  baseURL: config.apiURL,
})

httpApi.interceptors.request.use((config) => {
  config.headers = { ...config.headers, Authorization: `Bearer ${readToken()}` }

  return config
})

httpApi.interceptors.response.use(undefined, (error: AxiosError) => {
  return Promise.reject(new ApiError<ApiErrorData>(error.response?.data.message || error.message, error.response?.data))
})

export interface ApiErrorData {
  message: string
}
